export default function TypingDots() {
  return (
    <span className="fa-typing">
      <span />
      <span />
      <span />
    </span>
  );
}
